import { IdentifiableDto } from "./identifiable.dto";

export class CollectiveDto extends IdentifiableDto {
    name!: string;
    timestampCreated!: Date;
    timestampUpdated!: Date;
}